import EnterpriseLinksReviewTable from '@organisms/Tables/Enterprise/LinksReviewTable';

const EnterpriseLinksReview = () => <EnterpriseLinksReviewTable />;

export default EnterpriseLinksReview;
